import chatWidgetMode from '~/utils/chatWidgetMode';

function chatWidgetEnv() {
  // 舊的 .env 沒有這個鍵時，客戶端可能讀不到 process.env.CHAT_WIDGET_URL。
  try {
    return process.env.CHAT_WIDGET_URL;
  } catch (error) {
    return '';
  }
}

export default () => {
  if (process.client) {
    // 自家客服有網址時不載入 SaleSmartly，留空才維持原本的第三方泡泡。
    if (chatWidgetMode.useOwnChatWidget(chatWidgetEnv())) return;

    const injectScripts = () => {
      const src = chatWidgetMode.salesmartlyScriptUrl(chatWidgetEnv(), process.env.SALESMARTLY_KEY);
      if (src) {
        const sm = document.createElement('script');
        sm.src = src;
        sm.async = true;
        document.body.appendChild(sm);
      }
    };

    let injected = false;
    const trigger = () => {
      if (injected) return;
      injected = true;
      injectScripts();
      ['scroll', 'mousemove', 'touchstart'].forEach(e => window.removeEventListener(e, trigger));
    };

    // Delay for 3 seconds or trigger immediately on user interaction
    setTimeout(trigger, 3000);
    ['scroll', 'mousemove', 'touchstart'].forEach(e => window.addEventListener(e, trigger, { once: true, passive: true }));
  }
};
